import React, { useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Flex, Box, CriteriaTag } from "samba-ui";

const StyledInput = styled.input`
  border: none;
  width: 100%;
  height: 20px;
  font-size: 14px;
  &:focus {
    outline: none;
  }
`;

const VisibleOptionSetter = ({ tags = [], setTag, removeTag }) => {
  const inputEl = useRef(null);
  const inputKeyDown = e => {
    const { value } = e.target;
    if (e.key === "Enter" && value) {
      setTag(value);
      inputEl.current.value = null;
    } else if (e.key === "Backspace" && !value) {
      removeTag(tags.length - 1);
    }
  };

  return (
    <Flex border={1} borderRadius={4} flexWrap="wrap" p={2}>
      <Flex flexWrap="wrap" width={"100%"}>
        {tags.map((value, i) => (
          <Box mr={2} key={value}>
            <CriteriaTag onRemoveClick={() => removeTag(i)}>
              {value}
            </CriteriaTag>
          </Box>
        ))}
        <Box as="span">
          <StyledInput
            type="text"
            onKeyDown={inputKeyDown}
            ref={inputEl}
            placeholder="type and hit enter"
          />
        </Box>
      </Flex>
    </Flex>
  );
};

VisibleOptionSetter.propTypes = {
  tags: PropTypes.array,
  setTag: PropTypes.func,
  removeTag: PropTypes.func
};

export default VisibleOptionSetter;
